module.exports = __webpack_public_path__ + "img/nat-turner.9c91b667.png";